export const removeClassFromElementMatching = (className, element, selector) => {
  element.querySelectorAll(selector).forEach((el) => { el.classList.remove(className); });
};
